import { render } from "./modifyAddress.vue?vue&type=template&id=2a45f76b"
import script from "./modifyAddress.vue?vue&type=script&lang=js"
export * from "./modifyAddress.vue?vue&type=script&lang=js"

import "./modifyAddress.vue?vue&type=style&index=0&id=2a45f76b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__